/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/formula_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsFormulaData } from "./constants";
import type { AppsAppGroupIdChartsFormulaDataResult } from "./types";

export const getAppsAppGroupIdChartsFormulaData = reactQueryFetcherAdapter(
  appsAppGroupIdChartsFormulaData,
  (
    signal: AbortSignal,
    appGroupId: string,
    appIds: string[],
    startDate: number,
    endDate: number,
    formulaIds: string[],
    prefetchedData: string[]
  ): Promise<AppsAppGroupIdChartsFormulaDataResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/formula_data`,
      "GET",
      {
        app_ids: appIds,
        formula_ids: formulaIds,
        start_date: startDate,
        end_date: endDate,
        prefetched_data: prefetchedData,
      },
      { signal }
    );
  }
);
